export default {
  defaultFormGuideHeaders: [
    { id: 'career', title: 'Career' },
    { id: 'age', title: 'Age' },
    { id: 'wins', title: 'Win %' },
    { id: 'places', title: 'Place %' },
    { id: 'average', title: 'Average $' },
  ],
  defaultRaceEventHeaders: [
    { id: 'career', title: 'Career' },
    { id: 'rating', title: 'Rating' },
    { id: 'wins', title: 'Win %' },
    { id: 'places', title: 'Place %' },
  ],
  sortingOptionsGroup: {
    Horse: [
      { text: 'Runner Number (Default)', value: 'runnerNumber' },
      { text: 'Weight', value: 'weight' },
      { text: 'Barrier', value: 'barrier' },
      { text: 'Horse age', value: 'age' },
    ],
    'Horse Career': [{ text: 'Career win rate', value: 'winRate' }, { text: 'Career place rate', value: 'placeRate' }],
    'Prize Money': [
      { text: 'Career prize money', value: 'careerPrizeMoney' },
      { text: 'Average prize money', value: 'averagePrizeMoney' },
    ],
    Jockey: [{ text: 'Jockey wins', value: 'jockeyWins' }],
    Track: [{ text: 'Track wins', value: 'trackWins' }, { text: 'Distance wins', value: 'distanceWins' }],
  },
  defaultPlaceWinners: 3,
};
